import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

import { AppVersionStore } from "../store/store";
import { SUPPORT_PORTAL_URL } from "../data/installation-guides";
import { tokens } from "../styles/tokens";

/**
 * No longer wrapped in HideOnScroll: the app's scroll lock is gone, so that
 * wrapper would become live and slide the footer away on every scroll.
 */
export default function MyFooter() {
  const version = AppVersionStore((state) => state.version);

  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${tokens.color.hairline}`,
        bgcolor: "background.paper",
        pb: "env(safe-area-inset-bottom)",
        px: { mobile: 2.5, tablet: 4 },
      }}
    >
      <Box
        sx={{
          width: `min(100%, ${tokens.space.containerMax}px)`,
          mx: "auto",
          minHeight: 64,
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          alignItems: "center",
          justifyContent: "space-between",
          py: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {"Copyright © "}
          <Link color="inherit" href="https://artome.fi/" target="_blank" rel="noopener noreferrer">
            Artome Oy
          </Link>{" "}
          {new Date().getFullYear()} · v.{version}
        </Typography>

        <Link
          href={SUPPORT_PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
          sx={{ fontWeight: 700, color: "text.primary" }}
        >
          Artome support
        </Link>
      </Box>
    </Box>
  );
}
